import { createAction, props } from '@ngrx/store';
import { ScheduleCancel } from '../../models/schedule-cancel';

export const cancelSchedule = createAction(
    '[Cancel event]',
    props<{ cancelSchedule: ScheduleCancel }>()
);

export const cancelScheduleSuccess = createAction(
    '[Cancel event] success'
);

export const validateSchedule = createAction(
    '[Validate event]',
    props<{ validateSchedule: ScheduleCancel }>()
);

export const validateScheduleSuccess = createAction(
    '[Validate event] success'
);

export const removeSchedule = createAction(
    '[Remove event]',
    props<{ removeIdSchedules: number[] }>()
);

export const removeScheduleSuccess = createAction(
    '[Remove event] success'
);

export const resetUpdateSchedule = createAction(
    '[Reset event]'
);

export const validateBookingMemberSchedule = createAction(
    '[Validate booking members event]',
    props<{ idSchedule: number; bookingsMemberId: number[] }>()
);

export const resetBookingMemberValidation = createAction(
    '[Reset event]'
);

export const validateBookingMemberScheduleSuccess = createAction(
    '[Validate booking members event] success',
    props<{ idSchedule: number }>()
);

export const cancelBookingMemberSchedule = createAction(
    '[Cancel booking members event]',
    props<{ idSchedule: number; bookingsMemberId: number[] }>()
);

export const cancelBookingMemberScheduleSuccess = createAction(
    '[Cancel booking members event] success',
    props<{ idSchedule: number }>()
);

export const setNewBooking = createAction(
    '[Set new Booking]',
    props<{ idBookingMember: string; idSchedule: number; bookedSeat: number | null; checkPaymentRestriction: boolean; idMemberFee: string | null; forceBuyWithCredits: boolean }>()
);

export const setNewBookingSuccess = createAction(
    '[Set new booking] success',
    props<{ idSchedule: number }>()
);


export const setNewBookingFailed = createAction(
    '[Set new booking] failed',
    props<{ message: string }>()
);

export const resetNewBookingFailed = createAction(
    '[Set new booking] reset error message'
);

